import React, {Component} from 'react';

import wx from 'weixin-js-sdk'
// import { hourconvertMicrosecond, appShare, isWeChat } from '../../utils/utils'
import { wxshareApi, getShareContent } from '../../api/share'
import { global } from '../../config'
// import  from '../../api/fission'

//api
// import { wxShareInfoData , wxShareData } from '../async/wx';
//appid
// import { app_id } from '../api/config';
//工具类
// import { isWeiXin , getCookie } from '../utils';

/**
 * 微信分享
 * 自动判断是否是微信浏览器
 * 如果是，发送请求给服务器获取微信分享的权限
 * 如果不是, 不做任何处理
 * storeId : 店铺id ， 二选其一，弱
 * storeScenicId : 店铺景区id  二选其一，强
 */
 //微信分享
 class Share extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.share(this.props.obj)
    }

    componentWillReceiveProps() {
        let obj = this.props.obj
        if (obj && obj.title) {
            wx.onMenuShareTimeline({
                title: obj.title,
                link: obj.link,
                imgUrl : obj.imgUrl,
                success: function () {
                    alert('分享成功！');
                },
                cancel: function () {
                    alert('分享已取消！');
                }
            });
            wx.onMenuShareAppMessage({
                title: obj.title,
                link: obj.link,
                desc: obj.desc,
                imgUrl : obj.imgUrl,
                success: function () {
                    alert('分享成功！');
                },
                cancel: function () {
                    alert('分享已取消！');
                }
            });

            // wx.onMenuShareAppMessage({
            //     title: obj.title,
            //     link: obj.link,
            //     desc: obj.desc,
            //     imgUrl : obj.imgUrl,
            //     success: function () {
            //         alert('分享成功！');
            //     },
            //     cancel: function () {
            //         alert('分享已取消！');
            //     }
            // });
        }
    }

    /**
     * 微信分享
     * link : 需要分享的链接 默认为当前链接,
     * name : 需要分享链接的title
     * img  : 需要分享链接的图片
     * desc : 需要分享链接的描述
     */
    share = (obj) => {
        wxshareApi({
            url: window.location.href
        }).then((res)=>{
            wx.config({
                debug : false,
                appId : global.wxAppId,
                timestamp : res.timestamp,
                nonceStr  : res.noncestr,
                signature : res.signature,
                jsApiList : [
                    // 'updateTimelineShareData',      //分享到朋友圈
                    'onMenuShareTimeline',
                    // 'updateAppMessageShareData',    //分享给朋友
                    'onMenuShareAppMessage',
                    // 'onMenuShareQQ',            //分享给QQ
                    // 'onMenuShareWeibo',         //分享到腾讯微博
                    // 'onMenuShareQZone'          //分享到QQ空间
                ]
            });

            wx.ready(function(){
                wx.onMenuShareTimeline({
                    title: obj.title,
                    link: obj.link,
                    imgUrl : obj.imgUrl,
                    success: function () {
                        alert('分享成功！');
                    },
                    cancel: function () {
                        alert('分享已取消！');
                    }
                });

                wx.onMenuShareAppMessage({
                    title: obj.title,
                    link: obj.link,
                    desc: obj.desc,
                    imgUrl : obj.imgUrl,
                    success: function () {
                        alert('分享成功！');
                    },
                    cancel: function () {
                        alert('分享已取消！');
                    }
                });
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            });


        })
    }

    render(){
        return(
            <div />
        )
    }
}

export default Share;